<template>
  <div
    class="race-list-view-button"
    :class="{
      'race-list-view-button--for-pc': forPc,
    }"
  >
    <atom-icon-router-button
      class="race-list-view-button__button"
      to=""
      linkText="View All Sessions (Time Schedule)"
      theme="light"
      colorType="secondary"
      size="small"
      :imgPath="require('@/assets/img/icon/icon_schedule.svg')"
      @emitClick="handleViewTimetableClicked"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'
import AtomIconRouterButton from '@/components/atoms/AtomIconRouterButton.vue'

export default defineComponent({
  name: 'RaceListViewButtonParts',
  components: { AtomIconRouterButton },
  setup(_, { emit }) {
    const forPc = DeviceInfo.isForPC()
    const handleViewTimetableClicked = () => {
      emit('onClickViewTimetable')
    }
    return {
      forPc,
      handleViewTimetableClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.race-list-view-button {
  padding-top: 22px;
  padding-bottom: 14px;
  text-align: center;

  &::v-deep {
    .atom-icon-router-btn {
      display: inline-flex;
    }
  }

  &--for-pc {
    padding: 16px 0 0;
    text-align: left;

    &::v-deep {
      .atom-icon-router-btn {
        height: 2.8em;
        font-size: 15px;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
